module.exports = __webpack_public_path__ + "static/media/cargilbrta86.8db6392a.png";